import Base, { baseInit } from './base';

class Headline extends Base {
  _uuid = null; // String - internal field used for referencing creatives
  id = null; // Integer
  value = null;

  constructor(data) {
    super(data);
    baseInit(this, data, true);
  }


}

export { Headline };